import { User } from '@oneeducation/app-core';

export class userModel extends User {
  laName;
  userType;
  product: { name: string };
  schools: School[];
  localAuthority: LocalAuthority;
}

export class School {
  active;
  schoolId;
  schoolName;
  laId;
  schoolNumber;
  revokeAccess;
  contactNumber;
  principalEmail;
  accessGranted;
  dfeNumber: string;
}

export class LocalAuthority {
  active;
  administrator;
}
